import React from "react";
import CreateMerchantGatewayRates from "./CreateMerchantGatewayRates";
import CreateMerchantGatewayCurrency from "./CreateMerchantGatewayCurrency";
import Util from "../../../../libs/util";
import data from "currency-codes/data";

class CreateMerchantRatesv2 extends React.Component {
	constructor(props) {
		super(props);

		const priorityCode = ["SGD", "MYR", "USD"];
		const codes = [
			...data.filter((i) => priorityCode.includes(i.code)),
			...data.filter((i) => !priorityCode.includes(i.code)),
		];

		this.state = {
			currency: [
				...codes.map((d) => {
					return { name: d.code, value: d.number };
				}),
			],
			gatewayCurrency: Object.keys(props.gateway).reduce((acc, cur) => {
				if (cur !== "stripe" && cur !== "ipay88") {
					if (!acc[cur]) acc[cur] = [];
					acc[cur].push({ code: 702, name: "SGD" });
				} else if (cur === "ipay88") {
					if (!acc[cur]) acc[cur] = [];
					acc[cur].push({ code: 458, name: "MYR" });
				}
				return acc;
			}, {}),
			targetGateway: null,
		};
	}

	openModal = (gateway) => {
		this.setState({ targetGateway: gateway });
		Util.showModal("add-currency");
	};

	addCurrency = (currency) => {
		const { targetGateway, gatewayCurrency } = this.state;
		let current = { ...gatewayCurrency };
		if (!current[targetGateway]) {
			current[targetGateway] = [];
		}
		current[targetGateway].push({
			code: currency.value,
			name: currency.name,
		});
		this.props.addCurrency(targetGateway, currency);
		this.setState({ gatewayCurrency: current });
	};

	render() {
		const { gateway, baseRate, MDRTypes, enable, enableRate, setGatewayRates } =
			this.props;
		const { currency, gatewayCurrency, targetGateway } = this.state;

		let availableCurrency = [];
		if (targetGateway) {
			availableCurrency = currency.filter((i) => {
				return (
					gatewayCurrency[targetGateway].filter((j) => i.value === j.code)
						.length === 0
				);
			});
		}

		return (
			<>
				<CreateMerchantGatewayCurrency
					name="add-currency"
					targetGateway={targetGateway}
					currency={availableCurrency}
					addCurrency={this.addCurrency}
				/>
				<ul uk-tab="connect: #transaction-rates">
					{Object.keys(gateway).map((g, index) => (
						<li
							key={`${g}-rates-tab`}
							className={index === 0 ? "uk-active" : ""}
						>
							<a className="transaction-gateway-tab">
								<img
									className="uk-img"
									src={`data:image/*;base64,${gateway[g].image}`}
									width="50"
								/>
								{g !== "stripe" && (
									<button
										className="uk-margin-left uk-icon-button uk-button-primary"
										uk-icon="icon: fa-solid-plus-circle; ratio: 0.5"
										type="button"
										onClick={() => this.openModal(g)}
									/>
								)}
							</a>
						</li>
					))}
				</ul>
				<ul id="transaction-rates" className="uk-switcher uk-margin-bottom">
					{Object.keys(gateway).map((g, index) => {
						return (
							<CreateMerchantGatewayRates
								key={index}
								MDRTypes={MDRTypes}
								baseRate={baseRate}
								enable={enable}
								gateway={g}
								gatewayCurrency={gatewayCurrency}
								enableRate={enableRate}
								setGatewayRates={setGatewayRates}
							/>
						);
					})}
				</ul>
			</>
		);
	}
}

export default CreateMerchantRatesv2;
